import { DashboardEnrollmentPresenter, EnrollmentStage } from 'types/enrollmentService';
import { BiGroup } from 'types/groupService';

export type BiDashboardGroupPresenter = Pick<
  BiGroup,
  | 'id'
  | 'name'
  | 'agentOfRecord'
  | 'assigned'
  | 'source'
  | 'lastUpdateTime'
  | 'agency'
  | 'archived'
  | 'carrierGroupNumber'
  | 'contactInfo'
> & {
  enrollments: DashboardEnrollmentPresenter[];
};

export interface GroupAssigneeOption {
  id: string;
  name: string;
}

export interface SelectedGroupEnrollment {
  id: string;
  stage: EnrollmentStage;
}

export interface SelectedGroup {
  id: string;
  name: string;
  agencyId: string;
  enrollmentPeriodIds: string[];
  assigned: GroupAssigneeOption[];
  enrollments: SelectedGroupEnrollment[];
}

export enum GroupAction {
  REMOVE = 'REMOVE',
  ARCHIVE = 'ARCHIVE',
  MOVE = 'MOVE',
}

export interface BiGroupInteractionController {
  commitGroupAction(
    groupAction: GroupAction,
    groupId: string,
    groupName: string,
    agencyId: string,
    enrollmentPeriodIds: string[],
    assigned?: GroupAssigneeOption[],
    enrollments?: SelectedGroupEnrollment[],
  ): void;
  unarchiveGroup: (groupId: string) => Promise<void>;
  viewGroupProfile: (groupId: string, agencyId: string, agencyName: string) => Promise<void>;
}
